import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const dsn = config.public.sentryDsn as string
  const enabled = config.public.sentryEnabled as boolean

  // Si no hay DSN configurado o está deshabilitado, no inicializamos
  if (!dsn || !enabled) {
    if (import.meta.dev) {
      console.info('[Sentry] Disabled — no DSN or sentryEnabled=false')
    }
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn,
    environment: import.meta.dev ? 'development' : 'production',
    enabled: !import.meta.dev, // Sentry activo solo en producción
    integrations: [
      Sentry.browserTracingIntegration({
        router: useRouter(),
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
    // Release tagging — útil para correlacionar errores con deploys
    release: `comandaplus@${config.public.appVersion}`,
  })
})
